import { FieldInputProps } from 'react-final-form';

import { GDPRAuthProps } from '@blocks/auth/components/gdpr';
import { UserRole } from '@blocks/types';

import { USER_ROLE_CUSTOMER, USER_ROLE_WRITER } from '../constants';

export const getEvaluatedGDPRlinks = (
  {
    termsLink,
    termsLabel,
    policyLink,
    policyLabel,
    termLinkWriter,
    policyLinkWriter,
  }: GDPRAuthProps,
  userRole: FieldInputProps<UserRole, HTMLElement>,
) => {
  switch (userRole.value) {
    case USER_ROLE_CUSTOMER:
      return {
        termsLink,
        policyLink,
        termsLabel,
        policyLabel,
      };
    case USER_ROLE_WRITER:
      return {
        termsLink: termLinkWriter,
        policyLink: policyLinkWriter,
        termsLabel,
        policyLabel,
      };
    default:
      return {
        termsLink,
        policyLink,
        termsLabel,
        policyLabel,
      };
  }
};
